// Version : 0.0.2
// Author : VISHAL,ARANVINDHAN,VISHNU
// LastEdit : SHIYAM
// Last ADD : payload data changed to single line
// MODFIED DATE : 05-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import EconomicActivityActionTypes from './economicActivity.types';
import {
	economicActivityDetailsAdd,
	economicActivityDetailsUpdate,
	economicActivityListGet,
	economicActivityDetailsFetch,
	economicActivityDetailsDelete,
} from './economicActivity.service';
import {
	addEconomicActivityDetailsSuccess,
	addEconomicActivityDetailsFailure,
	addEconomicActivityDetailsResponseChanged,
	updateEconomicActivityDetailsSuccess,
	updateEconomicActivityDetailsFailure,
	updateEconomicActivityDetailsResponseChanged,
	getEconomicActivityListSuccess,
	getEconomicActivityListFailure,
	getEconomicActivityListResponseChanged,
	fetchEconomicActivityDetailsSuccess,
	fetchEconomicActivityDetailsFailure,
	fetchEconomicActivityDetailsResponseChanged,
	deleteEconomicActivityDetailsSuccess,
	deleteEconomicActivityDetailsFailure,
	deleteEconomicActivityDetailsResponseChanged,
} from './economicActivity.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET PRODUCT TYPE LIST  ******************** */
export function* economicActivityDetailsListGet({ payload }: any) {
	try {
		const key = 'GetEconomicActivityListKey';
		const { companyID, inputSearch, databaseName, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			SearchData: inputSearch,
			Limit: limit,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(economicActivityListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getEconomicActivityListFailure(responseData.data));
		} else {
			yield put(getEconomicActivityListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getEconomicActivityListFailure(error));
	}
}
export function* resetGetEconomicActivityListResponse() {
	yield put(getEconomicActivityListResponseChanged());
}
export function* onGetEconomicActivityListDetails() {
	yield takeLatest(
		EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_START,
		economicActivityDetailsListGet,
	);
}
export function* onGetEconomicActivityListResponseReset() {
	yield takeLatest(
		EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_RESPONSE_RESET,
		resetGetEconomicActivityListResponse,
	);
}
/** *********************  END GET PRODUCT TYPE LIST ******************** */

/** *********************  START DELETE PRODUCT TYPE DETAILS  ******************** */
export function* economicActivityDelete({ payload }: any) {
	try {
		const key = 'DeleteEconomicActivityDetailsKey';
		const {
			companyID,
			economicActivityID,
			economicActivityName,
			databaseName,
			userID,
			userAccessBranchID,
			userName,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			EconomicActivityID: economicActivityID,
			EconomicActivityName: economicActivityName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(economicActivityDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteEconomicActivityDetailsFailure(responseData.data));
		} else {
			yield put(deleteEconomicActivityDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteEconomicActivityDetailsFailure(error));
	}
}
export function* resetDeleteEconomicActivityDetailsResponse() {
	yield put(deleteEconomicActivityDetailsResponseChanged());
}
export function* onDeleteEconomicActivityDetail() {
	yield takeLatest(
		EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_START,
		economicActivityDelete,
	);
}
export function* onDeleteEconomicActivityResponseReset() {
	yield takeLatest(
		EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
		resetDeleteEconomicActivityDetailsResponse,
	);
}
/** *********************  END DELETE PRODUCT TYPE DETAILS ******************** */

/** *********************  START ADD ECONOMIC ACTVITY TYPE DETAILS  ******************** */
export function* createEconomicActivity({ payload }: any) {
	try {
		const key = 'AddEconomicActivityDetailKey';
		const { activityListArr, companyID, userID, userName, userAccessBranchID, databaseName } =
			payload;
		const jsonData = {
			EconomicActivityArrData: activityListArr,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(economicActivityDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addEconomicActivityDetailsFailure(responseData.data));
		} else {
			yield put(addEconomicActivityDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addEconomicActivityDetailsFailure(error));
	}
}
export function* resetAddEconomicActivityResponse() {
	yield put(addEconomicActivityDetailsResponseChanged());
}
export function* onCreateEconomicActivityDetails() {
	yield takeLatest(
		EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_START,
		createEconomicActivity,
	);
}
export function* onCreateEconomicActivityResponseReset() {
	yield takeLatest(
		EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
		resetAddEconomicActivityResponse,
	);
}
/** *********************  END ADD ECONOMIC ACTVITY DETAILS ******************** */

/** *********************  START UPDATE ECONOMIC ACTVITY DETAILS  ******************** */
export function* economicActivityUpdate({ payload }: any) {
	try {
		const key = 'UpdateEconomicActivityDetailsKey';
		const { activityListArr, companyID, userID, userName, userAccessBranchID, databaseName } =
			payload;
		const jsonData = {
			EconomicActivityArrData: activityListArr,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(economicActivityDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateEconomicActivityDetailsFailure(responseData.data));
		} else {
			yield put(updateEconomicActivityDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateEconomicActivityDetailsFailure(error));
	}
}
export function* resetUpdateEconomicActivityDetailsResponse() {
	yield put(updateEconomicActivityDetailsResponseChanged());
}
export function* onUpdateEconomicActivityDetails() {
	yield takeLatest(
		EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_START,
		economicActivityUpdate,
	);
}
export function* onUpdateEconomicActivityResponseReset() {
	yield takeLatest(
		EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
		resetUpdateEconomicActivityDetailsResponse,
	);
}
/** *********************  END UPDATE ECONOMIC ACTVITY  DETAILS ******************** */

/** *********************  START FETCH ECONOMIC ACTVITY  DETAILS  ******************** */
export function* fetchEconomicActivityData({ payload }: any) {
	try {
		const key = 'FetchEconomicActivityDetailsKey';
		const { companyID, economicActivityID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			EconomicActivityID: economicActivityID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(economicActivityDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchEconomicActivityDetailsFailure(responseData.data));
		} else {
			yield put(fetchEconomicActivityDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchEconomicActivityDetailsFailure(error));
	}
}
export function* resetFetchEconomicActivityDetailsResponse() {
	yield put(fetchEconomicActivityDetailsResponseChanged());
}
export function* onFetchEconomicActivityDetails() {
	yield takeLatest(
		EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_START,
		fetchEconomicActivityData,
	);
}
export function* onFetchEconomicActivityResponseReset() {
	yield takeLatest(
		EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
		resetFetchEconomicActivityDetailsResponse,
	);
}

/** *********************  END FETCH ECONOMIC ACTVITY DETAILS ******************** */
export function* economicActivityMasterSaga() {
	yield all([
		call(onCreateEconomicActivityDetails),
		call(onCreateEconomicActivityResponseReset),
		call(onUpdateEconomicActivityDetails),
		call(onUpdateEconomicActivityResponseReset),
		call(onGetEconomicActivityListDetails),
		call(onGetEconomicActivityListResponseReset),
		call(onFetchEconomicActivityDetails),
		call(onFetchEconomicActivityResponseReset),
		call(onDeleteEconomicActivityDetail),
		call(onDeleteEconomicActivityResponseReset),
	]);
}
